import type { RouteRecordRaw } from 'vue-router';

export const salonAppointmentsRoutes: RouteRecordRaw[] = [
  {
    path: 'salon-appointments',
    name: 'salon-appointments',
    component: () => import('./pages/SalonAppointmentsCalendarPage.vue'),
    meta: { title: 'Appointments', requiresAuth: true, permission: 'view_salon_appointments' },
  },
  {
    path: 'salon-appointments/list',
    name: 'salon-appointments.list',
    component: () => import('./pages/SalonAppointmentsListPage.vue'),
    meta: { title: 'Appointments', requiresAuth: true, permission: 'view_salon_appointments' },
  },
  {
    path: 'salon-appointments/new',
    name: 'salon-appointments.create',
    component: () => import('./pages/SalonAppointmentFormPage.vue'),
    meta: {
      title: 'New appointment',
      requiresAuth: true,
      permission: 'create_salon_appointments',
    },
  },
  {
    path: 'salon-appointments/:id',
    name: 'salon-appointments.show',
    component: () => import('./pages/SalonAppointmentFormPage.vue'),
    meta: { title: 'Appointment', requiresAuth: true, permission: 'view_salon_appointments' },
  },
];
